module.exports = __webpack_public_path__ + "img/MeuLote-pq-neg.0f0152ae.png";